/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from "react";
import { ChevronLeft } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

interface BackButtonProps {
  to: string;
  label?: string;
  onClick?: () => void;
}

export default function BackButton({ to, label, onClick }: BackButtonProps) {
  const { isRtl, t } = useLanguage();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (onClick) {
      onClick();
    } else {
      window.history.pushState({}, "", to);
      window.dispatchEvent(new Event("popstate"));
    }
  };

  return (
    <button
      onClick={handleClick}
      className="inline-flex items-center gap-2 text-xs text-amber-400 hover:text-amber-300 transition-all cursor-pointer font-sans"
    >
      <ChevronLeft className={`w-4 h-4 translate-y-[1px] ${isRtl ? "rotate-180" : ""}`} />
      <span>{label || t("backToHall")}</span>
    </button>
  );
}